// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__27WP7","icon":"styles_icon__B8BqF"};